export default "__VITE_ASSET__DfysqG_7__"